import { Alert, Badge, Breadcrumb, Button, Calendar, Col, DatePicker, Divider, Drawer, Dropdown, Empty, Flex, Form, Input, Layout, Pagination, Row, Select, Skeleton, Space, Steps, Table, Tabs, Tag, Tooltip, Typography, message, notification, theme } from 'antd';
import { HomeOutlined, SearchOutlined, CheckCircleOutlined, ClockCircleOutlined, FileZipOutlined, EyeOutlined } from '@ant-design/icons';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import dayjs from 'dayjs';
import MyEvents from './MyEvents';
import MyEventsPreview from './MyEventsPreview';
import CalendarDataAPI from '../../../restAPI/CalendarDataAPI';
import { useDispatch, useSelector } from 'react-redux';
import CreateNewMeetingDrawer from '../../../helperComponents/CreateNewMeeting/NewMeetingDrawer';
import ArchivedMeetingDetails from '../../../helperComponents/CreateNewMeeting/ArchivedOldMeetingDetails';
import { actionStateCapture, screenEnded } from '../../../redux/slices/meetingSlice';
import { useLocation } from 'react-router-dom';
import CommonSkeletonLoader from '../../../helperComponents/CommonSkeleton';
import MeetingAPI from '../../../restAPI/MeetingAPI';
import MasterDataAPI from '../../../restAPI/MasterDataAPI';
import LegacyAPI from '../../../restAPI/LegacyAPI';
import LegacyArchiveMeetingPreviewCardList from './components/LegacyArchiveMeetingPreviewCardList';
import 'dayjs/locale/en' // or 'si', 'ta', etc.
dayjs.locale('en')

const { RangePicker } = DatePicker;
const { Text } = Typography;

export default function Meeting() {
  const abortControllerRef = useRef(null);
  const originalTab4PaginationRef = useRef({ filteredCount: 0, hasNextPage: false });
  const [form] = Form.useForm()
  const location = useLocation();
  const dispatch = useDispatch();
  const { companyId, token, role, userCompany } = useSelector(state => state.auth);

  const [openMeetingDrawer, setOpenMeetingDrawer] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [startDate, setStartDate] = useState(null)
  const [selectedMeetingId, setSelectedMeetingId] = useState(null);
  const [selectedMeetingDate, setSelectedMeetingDate] = useState(null);
  const [selectedOriginalDate, setSelectedOriginalDate] = useState(null);
  const [selectedSingleMeeting, setSelectedSingleMeeting] = useState(null);
  const [selectedMeetingStatus, setSelectedMeetingStatus] = useState(null);
  const [selectedParticipantDetails, setSelectedParticipantDetails] = useState(null);
  const [selectedDays, setSelectedDays] = useState([]);
  const [dayMeetingList, setDayMeetingList] = useState([])
  const [dayRangeMeetingList, setDayRangeMeetingList] = useState([])
  const [isRecurring, setIsRecurring] = useState(false);
  const [skeletonLoading, setSkeletonLoading] = useState(false)
  const [monthRangeSeleced, setMonthRangeSeleced] = useState(false);
  const [openNewMeetingDrawer, setOpenNewMeetingDrawer] = useState(false);
  const [isPrevClickedToGeneral, setIsPrevClickedToGeneral] = useState(false);
  const [isPrevClickedToCommittee, setIsPrevClickedToCommittee] = useState(false);
  const [value2, setValue2] = useState('on');
  const [current, setCurrent] = useState(0);
  const [actionState, setActionState] = useState('add');
  const [triggerMeetings, setTriggerMeetings] = useState([]);
  const [finalAddedPapersList, setFinalAddedPapersList] = useState(null)
  const [rsvpDrawerLoading, setRsvpDrawerLoading] = useState(false);
  const [openArchivedDrawer, setOpenArchivedDrawer] = useState(false);

  const [activeTab, setActiveTab] = useState('2');
  const [committeeTypesList, setCommitteeTypesList] = useState([]);
  const [selectedCommitteeType, setSelectedCommitteeType] = useState(null);
  const [committeesList, setCommitteesList] = useState([]);
  const [selectedArchivedMeeting, setSelectedArchivedMeeting] = useState(null);
  const [selectedCommittee, setSelectedCommittee] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');

  const [tab1Meetings, setTab1Meetings] = useState({
    all: [],
    paginated: [],
    grouped: [],
    currentPage: 1,
    filteredCount: 0
  })
  const [tab2Meetings, setTab2Meetings] = useState({
    all: [],
    paginated: [],
    grouped: [],
    currentPage: 1,
    filteredCount: 0
  })
  const [tab3Meetings, setTab3Meetings] = useState({
    all: [],
    paginated: [],
    grouped: [],
    currentPage: 1,
    filteredCount: 0
  })

  const [tab4Meetings, setTab4Meetings] = useState({
    all: [],
    paginated: [],
    grouped: [],
    currentPage: 1,
    filteredCount: 0,
    hasNextPage: false
  })

  const pageSize = 20;
  const [dateRange, setDateRange] = useState([null, null]);

  const [api, contextHolder] = notification.useNotification();

  const queryParams = new URLSearchParams(location.search);
  const selectedDateFromCalendar = queryParams.get('date') ? dayjs(queryParams.get('date')) : dayjs();

  const openNotificationWithIcon = (type, message, description, placement) => {
    api[type]({
      message: message,
      description: description,
      placement
    });
  };

  function formatTime(dateTimeString) {
    const date = new Date(dateTimeString);
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';

    hours = hours % 12;
    hours = hours ? hours : 12;
    const strMinutes = minutes < 10 ? '0' + minutes : minutes;

    return `${hours}:${strMinutes} ${ampm}`;
  }
  const formatDate = (dateTimeString) => {
    // Parse the datetime string to a Date object
    const date = new Date(dateTimeString);

    // Extract the year, month, and day
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(date.getDate()).padStart(2, '0');

    // Return the formatted date string
    return `${year}-${month}-${day}`;
  };

  const fetchCommitteeTypes = async () => {
    try {
      let response;
      setCommitteesList([]);
      setSelectedCommittee(null);
      setSelectedCommitteeType(null);
      if (activeTab === '4') {
        response = await LegacyAPI.getCommitteeTypes(companyId, token);
      } else {
        const companyInfo = userCompany.companyData.find(company => company.companyId == companyId);
        response = await MasterDataAPI.getCommitteeTypesListForMeetingFilter(companyInfo?.userDetailsId, companyId, token);
      }

      if (response.status === 200) {
        let activeCommitteeTypes = [];

        if (activeTab === '4') {
          activeCommitteeTypes = response?.data?.data ? response.data.data.map(committee => {
            return { label: committee.name, value: committee.id };
          }) : [];
        } else {
          activeCommitteeTypes = response?.data ? response?.data.data.filter(committee => committee.status).map(committee => {
            return { label: committee.name, value: committee.id };
          }) : [];
        }

        setCommitteeTypesList(activeCommitteeTypes);
      } else {
        setCommitteeTypesList([])
      }
    } catch (error) {
      setCommitteeTypesList([])
      console.log('error in fetching data :', error)
    }
  }

  const fetchCommittiesFromCommitteeType = async (selected) => {
    try {
      if (!selected) return;

      let response;

      if (activeTab === '4') {
        response = await LegacyAPI.getCommitteesByCommitteeType(companyId, token, selected);
      } else {
        response = await MasterDataAPI.getCommitteesListForMeetingFilter(selected, companyId, token);
      }

      if (response.status === 200) {
        let activeCommittees = [];

        if (activeTab === '4') {
          activeCommittees = response?.data?.data ? response.data.data.map(committee => {
            return { label: committee.name, value: committee.id };
          }) : [];
        } else {
          activeCommittees = response?.data ? response?.data.data.filter(committee => committee.status).map(committee => {
            return { label: committee.name, value: committee.id };
          }) : [];
        }

        setCommitteesList(activeCommittees);
      } else {
        setCommitteesList([])
      }
    } catch (error) {
      setCommitteesList([])
    }
  }

  const fetchArchiveMeetings = async (page = 1) => {
    setSkeletonLoading(true);
    try {
      const meetingType = "archive";
      let finalStartDate, finalEndDate;

      if (startDate && endDate && dayjs(startDate).isValid() && dayjs(endDate).isValid()) {
        finalStartDate = dayjs(startDate).format('YYYY-MM-DD');
        finalEndDate = dayjs(endDate).format('YYYY-MM-DD');
      } else {
        finalEndDate = dayjs().format('YYYY-MM-DD');
        finalStartDate = dayjs().subtract(1, 'month').format('YYYY-MM-DD');
      }

      const requestSize = pageSize + 1;

      let response;
      if (selectedCommittee && activeTab === '4') {
        response = await LegacyAPI.getMeetingsByCommitteeId(companyId, token, selectedCommittee, meetingType, finalStartDate, finalEndDate, page, requestSize);
      } else {
        response = await LegacyAPI.getArchieveMeetingList(companyId, token, meetingType, finalStartDate, finalEndDate, page, requestSize);
      }
      const allMeetings = response?.data?.data?.meetings || [];

      const hasNextPage = allMeetings.length > pageSize;
      const meetings = hasNextPage ? allMeetings.slice(0, pageSize) : allMeetings;


      const items = meetings.map((meeting) => {
        const title = meeting?.meetingInfo?.name || '';
        const startDate = meeting?.meetingInfo?.startDate;
        const endDate = meeting?.meetingInfo?.endDate;

        const dateKey = startDate && dayjs(startDate).isValid()
          ? dayjs(startDate).format('YYYY-MM-DD')
          : 'Unknown';

        const formattedDate = startDate && dayjs(startDate).isValid()
          ? dayjs(startDate).format('MMM DD, YYYY')
          : '';

        let formattedTime = '';
        if (startDate && endDate) {
          formattedTime = `${formatTime(startDate)} – ${formatTime(endDate)}`;
        } else if (startDate) {
          formattedTime = formatTime(startDate);
        }

        return {
          key: meeting?.id,
          title,
          dateKey,
          formattedDate,
          formattedTime,
          raw: meeting,
        };
      });

      const groupedMap = new Map();
      items.forEach(item => {
        const dk = item.dateKey || 'Unknown';
        if (!groupedMap.has(dk)) groupedMap.set(dk, []);
        groupedMap.get(dk).push(item);
      });

      const groupedEntries = Array.from(groupedMap.entries()).sort((a, b) => {
        const dateA = a[0];
        const dateB = b[0];

        if (dateA === 'Unknown') return 1;
        if (dateB === 'Unknown') return -1;

        return dateB.localeCompare(dateA);
      });

      const currentPage = page || 1;

      const estimatedTotal = hasNextPage
        ? (currentPage * pageSize)
        : (currentPage - 1) * pageSize + meetings.length;

      originalTab4PaginationRef.current = {
        filteredCount: estimatedTotal,
        hasNextPage: hasNextPage
      };

      setTab4Meetings({
        all: items,
        paginated: items,
        grouped: groupedEntries,
        currentPage,
        filteredCount: estimatedTotal,
        hasNextPage,
      });
    } catch (error) {
      console.error('Error fetching old archive meetings:', error);
      setTab4Meetings({ all: [], paginated: [], grouped: [], currentPage: 1, filteredCount: 0, hasNextPage: false });
    } finally {
      setSkeletonLoading(false);
    }
  };

  useEffect(() => {
    if (queryParams.get('date')) {
      setSelectedDate(selectedDateFromCalendar);
    } else {
      setSelectedDate(dayjs());
    }
  }, [queryParams.get('date')]);

  useEffect(() => {
    if (selectedMeetingId || selectedOriginalDate || selectedMeetingDate) {
      setRsvpDrawerLoading(true);
      getMeetingByDayAndId();
    }
  }, [selectedMeetingId, selectedMeetingDate, selectedOriginalDate]);

  const getMeetingsByDatePeriod = async () => {
    setSkeletonLoading(true);
    try {
      const res = await CalendarDataAPI.getMeetingsByDatePeriod(startDate, endDate, companyId, token);
      if (res) {
        setMonthRangeSeleced(true);
        setDayRangeMeetingList(res.data);
        setDayMeetingList(res.data);
        if (monthRangeSeleced) {
          setSelectedParticipantDetails(res.data);
        }
      }
    } catch (error) {
      console.log("error in getMeetingsByDatePeriod :", error);
    } finally {
      setSkeletonLoading(false);
    }
  };


  const handleDateRangeChange = (dates) => {
    setDateRange(dates);
    if (dates && dates[0] && dates[1]) {
      setStartDate(dates[0]);
      setEndDate(dates[1]);
      fetchMeetingsAccordingToTab(activeTab, dates[0], dates[1]);
    } else {
      setStartDate(null);
      setEndDate(null);
      fetchMeetingsAccordingToTab(activeTab, null, null);
    }
  }

  const disabledDate = (current) => {
    const today = dayjs();
    const twelveMonthsAgo = today.subtract(3, 'month').startOf('day');
    const twelveMonthsLater = today.add(3, 'month').endOf('day');
    return (
      current && (current < twelveMonthsAgo || current > twelveMonthsLater)
    );
  };

  const sortMeetingsRawList = (rawList, isPreviousTab = false) => {
    // sort meetings within each date
    rawList.forEach(dateGroup => {
      dateGroup.meetings.sort((firstMeeting, secondMeeting) => {
        const firstTime = dayjs(firstMeeting?.info?.startDate).valueOf();
        const secondTime = dayjs(secondMeeting?.info?.startDate).valueOf();
        return isPreviousTab ? secondTime - firstTime : firstTime - secondTime;
      })
    })

    // Sort days
    rawList.sort((firstGroup, secondGroup) => {
      const firstDate = dayjs(firstGroup?.meetingDate).valueOf();
      const secondDate = dayjs(secondGroup?.meetingDate).valueOf();
      return isPreviousTab ? secondDate - firstDate : firstDate - secondDate;
    })

    return rawList;
  }

  const fetchMeetingsAccordingToTab = async (tabKey, start = null, end = null) => {
    setSkeletonLoading(true);
    // abort the previous request
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    // create a new controller
    const controller = new AbortController();
    abortControllerRef.current = controller;

    const selectedDateForAPI = selectedDate ? dayjs(selectedDate).toISOString() : dayjs().toISOString()
    const selectedStart = start ? dayjs(start).toISOString() : null;
    const selectedEnd = end ? dayjs(end).toISOString() : null;

    try {
      let results = null;
      if (tabKey === "1") {
        results = await MeetingAPI.getMeetingsForPreviousMonth(selectedDateForAPI, selectedStart, selectedEnd, companyId, token, controller.signal);
      } else if (tabKey === "2") {
        results = await MeetingAPI.getMeetingsForUpcomingMonth(selectedDateForAPI, selectedStart, selectedEnd, companyId, token, controller.signal);
      } else if (tabKey === "3") {
        results = await MeetingAPI.getMeetingsForArchive(selectedDateForAPI, selectedStart, selectedEnd, companyId, token, controller.signal);
      }

      if (abortControllerRef.current !== controller) return;

      if (results?.status === 200) {
        const rawList = results.data?.data || [];

        //const sortedRawList = sortMeetingsRawList(rawList, tabKey === "1");
        const sortedRawList = sortMeetingsRawList(rawList, (tabKey === "1" || tabKey === "3"));
        let flattenedMeetings = sortedRawList.flatMap(dateGroup =>
          dateGroup.meetings.map(meeting => ({
            ...meeting,
            meetingDate: dateGroup.meetingDate,
          }))
        );

        // For archive tab (tabKey === "3"), only show meetings with status "archive"
        if (tabKey === "3") {
          flattenedMeetings = flattenedMeetings.filter(meeting => meeting.status === "archive");
        }

        const currentPage = tabKey === "1" ? tab1Meetings.currentPage : tabKey === "2" ? tab2Meetings.currentPage : tab3Meetings.currentPage;

        const paginated = flattenedMeetings.slice((currentPage - 1) * pageSize, currentPage * pageSize);

        const grouped = new Map();
        paginated.forEach(meeting => {
          const dateKey = dayjs(meeting.meetingDate).format('YYYY-MM-DD');
          if (!grouped.has(dateKey)) grouped.set(dateKey, []);
          grouped.get(dateKey).push(meeting);
        });

        const newState = {
          all: flattenedMeetings,
          paginated,
          grouped: Array.from(grouped.entries()),
          currentPage,
          filteredCount: flattenedMeetings.length
        };

        if (tabKey === "1") {
          setTab1Meetings(newState);
        } else if (tabKey === "2") {
          setTab2Meetings(newState);
        } else if (tabKey === "3") {
          setTab3Meetings(newState);
        }

      } else {
        const resetState = { all: [], paginated: [], grouped: [], currentPage: 1, filteredCount: 0 };
        if (tabKey === "1") setTab1Meetings(resetState);
        else if (tabKey === "2") setTab2Meetings(resetState);
        else if (tabKey === "3") setTab3Meetings(resetState);
      }
    } catch (error) {
      if (error.name === 'AbortError') {
        console.log(`Fetch for tab ${tabKey} aborted.`);
      } else {
        console.error(`Error fetching tab ${tabKey}:`, error);
      }
    } finally {
      if (abortControllerRef.current === controller) {
        setSkeletonLoading(false);
      }
    }
  }

  const handlePageChange = (page) => {
    if (activeTab === "1") {
      setTab1Meetings(prev => ({ ...prev, currentPage: page }));
    } else if (activeTab === "2") {
      setTab2Meetings(prev => ({ ...prev, currentPage: page }));
    } else if (activeTab === "3") {
      setTab3Meetings(prev => ({ ...prev, currentPage: page }));
    } else if (activeTab === "4") {
      setTab4Meetings(prev => ({ ...prev, currentPage: page }));
      fetchArchiveMeetings(page);
    }
  };

  useEffect(() => {
    if (activeTab && companyId) {
      setSkeletonLoading(true);
      setTab1Meetings({ currentPage: 1 })
      setTab2Meetings({ currentPage: 1 })
      setTab3Meetings({ currentPage: 1 })
      setTab4Meetings({ currentPage: 1 })

      if (activeTab === '4') {
        fetchArchiveMeetings(1);
      } else {
        fetchMeetingsAccordingToTab(
          activeTab,
          dateRange && dateRange[0] ? dateRange[0] : null,
          dateRange && dateRange[1] ? dateRange[1] : null
        );
      }
    }
  }, [activeTab, companyId, startDate, endDate, selectedCommittee]);

  useEffect(() => {
    if (!activeTab) return;

    if (activeTab === '4') {
      const allMeetings = Array.isArray(tab4Meetings?.all) ? tab4Meetings.all : [];

      if (searchQuery !== '') {

        const filteredMeetings = allMeetings.filter(m => {
          const name = m?.title || '';
          return name.toLowerCase().includes(searchQuery.toLowerCase());
        });

        const groupedMap = new Map();
        filteredMeetings.forEach(meeting => {
          const dateKey = meeting?.dateKey || 'Unknown';
          if (!groupedMap.has(dateKey)) groupedMap.set(dateKey, []);
          groupedMap.get(dateKey).push(meeting);
        });

        const groupedEntries = Array.from(groupedMap.entries()).sort((a, b) => {
          const dateA = a[0];
          const dateB = b[0];

          if (dateA === 'Unknown') return 1;
          if (dateB === 'Unknown') return -1;

          return dateB.localeCompare(dateA);
        });

        setTab4Meetings(prev => ({
          ...prev,
          paginated: filteredMeetings,
          grouped: groupedEntries,
          filteredCount: filteredMeetings.length,
        }));
      } else {
        const groupedMap = new Map();
        allMeetings.forEach(meeting => {
          const dateKey = meeting?.dateKey || 'Unknown';
          if (!groupedMap.has(dateKey)) groupedMap.set(dateKey, []);
          groupedMap.get(dateKey).push(meeting);
        });

        const groupedEntries = Array.from(groupedMap.entries()).sort((a, b) => {
          const dateA = a[0];
          const dateB = b[0];

          if (dateA === 'Unknown') return 1;
          if (dateB === 'Unknown') return -1;

          return dateB.localeCompare(dateA);
        });

        setTab4Meetings(prev => ({
          ...prev,
          paginated: prev.all || [],
          grouped: groupedEntries,
          filteredCount: originalTab4PaginationRef.current.filteredCount,
          hasNextPage: originalTab4PaginationRef.current.hasNextPage
        }));
      }
      return;
    }

    const currentTab = activeTab === "1" ? tab1Meetings : activeTab === '2' ? tab2Meetings : tab3Meetings;
    const allMeetings = Array.isArray(currentTab?.all) ? currentTab.all : [];

    const filterMeetings = selectedCommittee ? allMeetings.filter(m => m?.committeeId == selectedCommittee) : allMeetings;

    const filteredMeetings2 = searchQuery.length !== 0 ? filterMeetings.filter(m => {
      const name = m?.info?.name || '';
      return name.toLowerCase().includes(searchQuery.toLowerCase());
    }) : filterMeetings;

    const paginated = filteredMeetings2.slice((currentTab.currentPage - 1) * pageSize, currentTab.currentPage * pageSize);

    const groupedMap = new Map();
    paginated.forEach(meeting => {
      const dateKey = dayjs(meeting.meetingDate).format('YYYY-MM-DD');
      if (!groupedMap.has(dateKey)) groupedMap.set(dateKey, []);
      groupedMap.get(dateKey).push(meeting);
    });

    const updatedTab = {
      ...currentTab,
      paginated,
      grouped: Array.from(groupedMap.entries()),
      filteredCount: filteredMeetings2.length
    };

    if (activeTab === "1") {
      setTab1Meetings(updatedTab);
    } else if (activeTab === "2") {
      setTab2Meetings(updatedTab);
    } else if (activeTab === "3") {
      setTab3Meetings(updatedTab);
    }
  }, [activeTab, tab1Meetings.currentPage, tab2Meetings.currentPage, tab3Meetings.currentPage, tab4Meetings.currentPage, tab1Meetings.all, tab2Meetings.all, tab3Meetings.all, tab4Meetings.all, searchQuery, selectedCommittee, selectedCommitteeType]);

  useEffect(() => {
    if (activeTab === "1") {
      setTab1Meetings(prev => ({ ...prev, currentPage: 1 }));
    } else if (activeTab === "2") {
      setTab2Meetings(prev => ({ ...prev, currentPage: 1 }));
    } else if (activeTab === "3") {
      setTab3Meetings(prev => ({ ...prev, currentPage: 1 }));
    } else if (activeTab === "4") {
      setTab4Meetings(prev => ({ ...prev, currentPage: 1 }));
    }
  }, [selectedCommittee, selectedCommitteeType, activeTab]);

  useEffect(() => {
    if (companyId) {
      fetchCommitteeTypes()
    }
  }, [companyId, activeTab])

  useEffect(() => {
    if (selectedCommitteeType) {
      fetchCommittiesFromCommitteeType(selectedCommitteeType)
    } else {
      setSelectedCommittee(null)
    }
  }, [selectedCommitteeType])


  const getMeetingByDayAndId = async () => {
    try {
      // if logged in user is sec or assistant sec, response containe all participants details.
      // otherwise only loggedin user's details will be there.
      // const res = await CalendarDataAPI.getMeetingsByDateAndId(
      const res = await CalendarDataAPI.getMeetingsByIdAndDateForMeetingView(
        selectedMeetingDate,
        selectedMeetingId,
        selectedOriginalDate,
        companyId,
        token
      );

      if (res) {
        setSelectedSingleMeeting(res.data)
        setRsvpDrawerLoading(false)
      } else {
        setRsvpDrawerLoading(false)
      }
    } catch (error) {
      setRsvpDrawerLoading(false)
      console.log("Error in getMeetingByDayAndId :", error);
    }
  }

  const {
    token: {
      colorBgContainer,
      borderRadiusLG,
      colorPrimary,
      colorError,
      colorBorder },
  } = theme.useToken();

  const showSingleMeetingDrawer = (id, meetingDate, originalDate, status) => {
    setSelectedMeetingId(id);
    setSelectedMeetingDate(meetingDate);
    setSelectedOriginalDate(originalDate);
    setSelectedMeetingStatus(status);
    setOpenMeetingDrawer(true);
  };
  const closeSingleMeetingDrawer = () => {
    if (!monthRangeSeleced) {
      fetchMeetingsAccordingToTab(activeTab, dateRange && dateRange[0] ? dateRange[0] : null, dateRange && dateRange[1] ? dateRange[1] : null);
    }
    else {
      getMeetingsByDatePeriod();
    }
    setSelectedMeetingId(null);
    setSelectedMeetingDate(null);
    setSelectedOriginalDate(null);
    setSelectedSingleMeeting(null);
    setSelectedMeetingStatus(null);
    setOpenMeetingDrawer(false);
  };


  const onRangeChange = (dates, dateStrings) => {
    setMonthRangeSeleced(true);
    if (dates && dates.length === 2) {
      const start = dates[0];
      const end = dates[1];
      setStartDate(start.format('DD MMM YYYY'));
      setEndDate(end.format('DD MMM YYYY'));
    } else {
      setStartDate(null);
      setEndDate(null);
    }
  };

  const showNewMeetingDrawer = () => {
    setOpenNewMeetingDrawer(true);
    dispatch(screenEnded());
    dispatch(actionStateCapture('add'));
  };

  const showArchivedDrawer = async (meeting) => {
    try {
      const response = await LegacyAPI.getLegacyMeetingDetails(companyId, token, meeting.id);
      setSelectedArchivedMeeting(response.data.data);
      setOpenArchivedDrawer(true);
    } catch (error) {
      console.log('error fetching meeting details: ', error);
    }
  };

  const onCloseArchivedDrawer = () => {
    setSelectedArchivedMeeting(null);
    setOpenArchivedDrawer(false);
  };

  const onCloseNewMeetingDrawer = () => {
    if (actionState === 'add') {
      form.resetFields()
      setStartDate(null)
      setEndDate(null)
      setDateRange([null, null])
      setSearchQuery('')
    }
    setSelectedDate(dayjs().format('YYYY-MM-DD HH:mm'))
    setSelectedCommitteeType(null)
    setSelectedCommittee(null)
    setOpenNewMeetingDrawer(false);
    setIsRecurring(false);
    setSelectedDays([]);
    setValue2('on');
    setCurrent(0);
    setIsPrevClickedToGeneral(false);
    setIsPrevClickedToCommittee(false);
    dispatch(screenEnded());
    // fetchMeetingsAccordingToTab(activeTab);
    fetchMeetingsAccordingToTab(activeTab, dateRange && dateRange[0] ? dateRange[0] : null, dateRange && dateRange[1] ? dateRange[1] : null);
  };

  const [visible, setVisible] = useState(false);

  const handleCalendarClick = () => {
    setVisible(true);
  };

  const handleOpenChange = (open) => {
    if (!open) {
      setVisible(false);
    }
  };

  const renderMeetingList = () => {
    const meetingList = startDate && endDate ? dayRangeMeetingList : dayMeetingList;

    if (skeletonLoading) {
      return <Skeleton active />;
    }

    if (meetingList.length === 0) {
      return (
        <Flex align='center' justify='center' style={{ minHeight: 300 }} >
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={
              <Text>No meetings were scheduled.</Text>
            }
          />
        </Flex>
      );
    }

    // Extract all meetings
    let allMeetings = [];
    meetingList.forEach(day => {
      day.meetings.forEach(meeting => {
        allMeetings.push({ ...meeting, meetingDate: day.meetingDate });
      });
    });

    // Sort the meetings by startDate
    allMeetings.sort((a, b) => new Date(a.info.startDate) - new Date(b.info.startDate));

    // Map through the sorted meetings to render them
    return allMeetings.map((single, index) => (
      // console.log('singleMeeting :', single),
      <MyEventsPreview
        key={index}
        company='default'
        meetingId={single._id}
        selectedDate={selectedDate}
        fullMeetingDetails={single}
        meetingStatus={single.status}
        selectedMeetingId={single._id}
        committeeId={single.committeeId}
        setSelectedDate={setSelectedDate}
        fetchMeetingsAccordingToTab={fetchMeetingsAccordingToTab}
        meetingDate={formatDate(single.meetingDate)}
        originalDate={formatDate(single.originalDate)}
        showSingleMeetingDrawer={showSingleMeetingDrawer}
        name={single?.info ? single?.info?.name : "No meeting data"}
        meetingParticipation={single?.participant ? single?.participant?.member.type : 'original'}
        date={monthRangeSeleced ? formatDate(single.originalDate) : selectedDate.format('YYYY-MM-DD')}
        time={single?.info ? `${formatTime(single.info.startDate)} - ${formatTime(single.info.endDate)}` : "No meeting data"}
        status={single?.participant ? single?.participant?.member?.attendance === "mandatory" ? "Yes" : single?.participant?.member.rsvp == 'Default' ? "RSVP" : single?.participant?.member.rsvp : 'RSVP'}
        triggerMeetings={triggerMeetings}
        setTriggerMeetings={setTriggerMeetings}
        openNotificationWithIcondd={openNotificationWithIcon}
      />
    ));
  };

  const handleTagsClose = () => {
    setMonthRangeSeleced(false);
    setStartDate(null);
    setEndDate(null);
    fetchMeetingsAccordingToTab('2');
    setDateRange([null, null])
    form.resetFields(['startEndDate'])
  };

  return (
    <>
      {contextHolder}
      <Flex gap={20} justify='space-between' align='center' style={{
        margin: '16px',
        padding: '16px 24px',
        // minHeight: 280,
        background: colorBgContainer,
        borderRadius: borderRadiusLG,
      }}>
        <Breadcrumb
          items={[
            {
              title: <HomeOutlined />,
            },
            {
              title: 'Meeting Management / Meetings',
            },
          ]}
        />
        <Flex justify='center' align='center' gap={12}>
          {visible && (
            <RangePicker
              format="YYYY/MM/DD"
              onChange={onRangeChange}
              onOpenChange={handleOpenChange}
              open={visible}
              needConfirm
            />
          )}
          {(role.some(r => r.roleName === "Secretary") || role.some(r => r.roleName === "Assistant Secretary")) && (
            <Button type="primary" onClick={showNewMeetingDrawer}>Add New</Button>
          )}
        </Flex>
      </Flex>
      <Flex gap={20} justify='space-between' align='center' style={{
        margin: '32px 0 0px 16px',
      }}>
        <Form form={form} style={{ width: '100%' }} >
          <Row gutter={[16, 16]} style={{ width: '100%' }}>
            {/* Bug 14356 - fixes */}
            <Col span={6}>
              <Form.Item name="committeeType" layout='vertical'>
                <Select
                  allowClear
                  placeholder="Select Committee Type"
                  options={committeeTypesList}
                  onChange={(value) => {
                    setSelectedCommitteeType(value)
                    form.resetFields(['Committee'])
                    if (!value) {
                      setSelectedCommittee('')
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="Committee" layout='vertical'>
                <Select
                  allowClear
                  placeholder="Select Committee"
                  options={committeesList}
                  onChange={(value) => {
                    setSelectedCommittee(value)
                  }}
                  value={selectedCommittee}
                  disabled={!selectedCommitteeType}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name="startEndDate"
                layout='vertical'
              >
                <RangePicker
                  format="YYYY/MM/DD"
                  value={dateRange}
                  onChange={handleDateRangeChange}
                  allowClear
                  disabledDate={disabledDate}
                  style={{ width: '100%' }}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name="searchText"
                layout='vertical'
              >
                <Input
                  placeholder="Search Text"
                  suffix={
                    <SearchOutlined style={{ color: colorBorder }} />
                  }
                  // allowClear
                  value={searchQuery}
                  onChange={(e) => {
                    setSearchQuery(e.target.value)
                    if (activeTab === '1') {
                      setTab1Meetings(prev => ({ ...prev, currentPage: 1 }))
                    } else if (activeTab === '2') {
                      setTab2Meetings(prev => ({ ...prev, currentPage: 1 }))
                    } else if (activeTab === '3') {
                      setTab3Meetings(prev => ({ ...prev, currentPage: 1 }))
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Alert message="Data is available for viewing up to 3 months only." type="info" showIcon closable />
            </Col>
          </Row>
        </Form>
      </Flex>

      <div style={{ margin: '16px' }}>
        {startDate && endDate &&
          <Flex align='center' gap={12}>
            <Tag bordered={false} closable color="success" onClose={() => handleTagsClose()}>
              {`${dayjs(startDate).format('ddd, DD MMM YYYY')} To ${dayjs(endDate).format('ddd, DD MMM YYYY')}`}
            </Tag>
          </Flex>
        }
      </div>
      <Flex gap={20} align='center' style={{
        margin: '16px',
        borderRadius: borderRadiusLG,
      }}>

        {/* refactor this tab in another time to display tabs according to the role. */}
        <Tabs
          defaultActiveKey="2"
          activeKey={activeTab}
          onChange={(key) => setActiveTab(key)}
          width='100%'
          style={{ width: '100%' }}
          items={[
            {
              label: 'Previous',
              key: '1',
              children: (
                <Flex vertical gap={16} style={{ width: '100%' }}>
                  {
                    skeletonLoading ? (
                      <CommonSkeletonLoader itemCount={3} />
                    ) : Array.isArray(tab1Meetings?.grouped) && tab1Meetings?.grouped?.length === 0 ? (
                      <Flex align="center" justify="center" style={{ minHeight: 300 }}>
                        <Empty
                          image={Empty.PRESENTED_IMAGE_SIMPLE}
                          description={
                            <span>No meetings were scheduled.</span>
                          }
                        />
                      </Flex>
                    ) : (
                      <>
                        {
                          Array.isArray(tab1Meetings?.grouped) && tab1Meetings.grouped.map(([date, meetings]) => (
                            <div key={date}>
                              <Flex gap={16} align="center" justify="flex-start" style={{ fontSize: 24 }}>
                                <div
                                  style={{
                                    backgroundColor: colorPrimary,
                                    padding: '8px 12px',
                                    borderRadius: borderRadiusLG,
                                    color: '#fff',
                                  }}
                                >
                                  {dayjs(date).format('DD')}
                                </div>
                                <div>{dayjs(date).format('dddd, MMMM, YYYY')}</div>
                              </Flex>
                              <div>
                                {meetings.map(meeting => (
                                  <MyEventsPreview
                                    // key={meeting._id}
                                    key={`${meeting._id}-${dayjs(meeting.originalDate).format('YYYY-MM-DD')}`}
                                    company="default"
                                    meetingId={meeting._id}
                                    selectedDate={selectedDate}
                                    fullMeetingDetails={meeting}
                                    meetingStatus={meeting.status}
                                    selectedMeetingId={meeting._id}
                                    committeeId={meeting.committeeId}
                                    setSelectedDate={setSelectedDate}
                                    activeTab={activeTab}
                                    dateRange={dateRange}
                                    fetchMeetingsAccordingToTab={fetchMeetingsAccordingToTab}
                                    meetingDate={formatDate(meeting.meetingDate)}
                                    originalDate={formatDate(meeting.originalDate)}
                                    showSingleMeetingDrawer={showSingleMeetingDrawer}
                                    name={meeting.info?.name || 'No meeting data'}
                                    meetingParticipation={meeting.participant?.member?.type || 'original'}
                                    date={monthRangeSeleced ? formatDate(meeting.originalDate) : dayjs(meeting?.meetingDate).format("YYYY-MM-DD")}
                                    time={meeting.info ? `${formatTime(meeting.info.startDate)} - ${formatTime(meeting.info.endDate)}` : 'No meeting data'}
                                    status={meeting.participant?.member?.attendance === 'mandatory' ? 'Yes' : meeting.participant?.member?.rsvp === 'Default' ? 'RSVP' : meeting.participant?.member?.rsvp || 'RSVP'}
                                    triggerMeetings={triggerMeetings}
                                    setTriggerMeetings={setTriggerMeetings}
                                    openNotificationWithIcondd={openNotificationWithIcon}
                                  />
                                ))}
                              </div>
                            </div>
                          ))
                        }
                        <Pagination
                          align='end'
                          current={tab1Meetings.currentPage}
                          total={tab1Meetings.filteredCount}
                          pageSize={pageSize}
                          onChange={handlePageChange}
                          showSizeChanger={false}
                        />
                      </>
                    )
                  }
                </Flex>
              ),
              icon: <CheckCircleOutlined />
            },
            {
              label: 'Upcoming',
              key: '2',
              children: (
                <Flex vertical gap={16} style={{ width: '100%' }}>
                  {
                    skeletonLoading ? (
                      <CommonSkeletonLoader itemCount={2} />
                    ) : Array.isArray(tab2Meetings?.grouped) && tab2Meetings.grouped.length === 0 ? (
                      <Flex align="center" justify="center" style={{ minHeight: 300 }}>
                        <Empty
                          image={Empty.PRESENTED_IMAGE_SIMPLE}
                          description={
                            <span>No meetings were scheduled.</span>
                          }
                        />
                      </Flex>
                    ) : (
                      <>
                        {
                          Array.isArray(tab2Meetings?.grouped) && tab2Meetings.grouped.map(([date, meetings]) => (
                            <div key={date}>
                              <Flex gap={16} align="center" justify="flex-start" style={{ fontSize: 24 }}>
                                <div
                                  style={{
                                    backgroundColor: colorPrimary,
                                    padding: '8px 12px',
                                    borderRadius: borderRadiusLG,
                                    color: '#fff',
                                  }}
                                >
                                  {dayjs(date).format('DD')}
                                </div>
                                <div>{dayjs(date).format('dddd, MMMM, YYYY')}</div>
                              </Flex>
                              <div>
                                {meetings.map(meeting => (
                                  <MyEventsPreview
                                    // key={meeting._id}
                                    key={`${meeting._id}-${dayjs(meeting.originalDate).format('YYYY-MM-DD')}`}
                                    company="default"
                                    meetingId={meeting._id}
                                    selectedDate={selectedDate}
                                    fullMeetingDetails={meeting}
                                    meetingStatus={meeting.status}
                                    selectedMeetingId={meeting._id}
                                    committeeId={meeting.committeeId}
                                    setSelectedDate={setSelectedDate}
                                    activeTab={activeTab}
                                    dateRange={dateRange}
                                    fetchMeetingsAccordingToTab={fetchMeetingsAccordingToTab}
                                    meetingDate={formatDate(meeting.meetingDate)}
                                    originalDate={formatDate(meeting.originalDate)}
                                    showSingleMeetingDrawer={showSingleMeetingDrawer}
                                    name={meeting.info?.name || 'No meeting data'}
                                    meetingParticipation={meeting.participant?.member?.type || 'original'}
                                    date={monthRangeSeleced ? formatDate(meeting.originalDate) : dayjs(meeting?.meetingDate).format("YYYY-MM-DD")}
                                    time={meeting.info ? `${formatTime(meeting.info.startDate)} - ${formatTime(meeting.info.endDate)}` : 'No meeting data'}
                                    status={meeting.participant?.member?.attendance === 'mandatory' ? 'Yes' : meeting.participant?.member?.rsvp === 'Default' ? 'RSVP' : meeting.participant?.member?.rsvp || 'RSVP'}
                                    triggerMeetings={triggerMeetings}
                                    setTriggerMeetings={setTriggerMeetings}
                                    openNotificationWithIcondd={openNotificationWithIcon}
                                  />
                                ))}
                              </div>
                            </div>
                          ))
                        }
                        <Pagination
                          align='end'
                          current={tab2Meetings.currentPage}
                          total={tab2Meetings.filteredCount}
                          pageSize={pageSize}
                          onChange={handlePageChange}
                          showSizeChanger={false}
                        />
                      </>
                    )
                  }
                </Flex>
              ),
              icon: <ClockCircleOutlined />,
            },
            ...[
              {
                label: (
                  <span style={{ color: colorError }}>
                    <FileZipOutlined style={{ color: colorError }} /> Archive
                  </span>
                ),
                key: '3',
                children: (
                  <Flex vertical gap={16} style={{ width: '100%' }}>
                    {
                      skeletonLoading ? (
                        <CommonSkeletonLoader itemCount={2} />
                      ) : Array.isArray(tab3Meetings?.grouped) && tab3Meetings.grouped.length === 0 ? (
                        <Flex align="center" justify="center" style={{ minHeight: 300 }}>
                          <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description={
                              <span>No meetings were scheduled.</span>
                            }
                          />
                        </Flex>
                      ) : (
                        <>
                          {
                            Array.isArray(tab3Meetings?.grouped) && tab3Meetings.grouped.map(([date, meetings]) => (
                              <div key={date}>
                                <Flex gap={16} align="center" justify="flex-start" style={{ fontSize: 24 }}>
                                  <div
                                    style={{
                                      backgroundColor: colorPrimary,
                                      padding: '8px 12px',
                                      borderRadius: borderRadiusLG,
                                      color: '#fff',
                                    }}
                                  >
                                    {dayjs(date).format('DD')}
                                  </div>
                                  <div>{dayjs(date).format('dddd, MMMM, YYYY')}</div>
                                </Flex>
                                <div>
                                  {meetings.map(meeting => (
                                    <MyEventsPreview
                                      // key={meeting._id}
                                      key={`${meeting._id}-${dayjs(meeting.originalDate).format('YYYY-MM-DD')}`}
                                      company="default"
                                      meetingId={meeting._id}
                                      selectedDate={selectedDate}
                                      fullMeetingDetails={meeting}
                                      meetingStatus={meeting.status}
                                      selectedMeetingId={meeting._id}
                                      committeeId={meeting.committeeId}
                                      setSelectedDate={setSelectedDate}
                                      activeTab={activeTab}
                                      dateRange={dateRange}
                                      fetchMeetingsAccordingToTab={fetchMeetingsAccordingToTab}
                                      meetingDate={formatDate(meeting.meetingDate)}
                                      originalDate={formatDate(meeting.originalDate)}
                                      showSingleMeetingDrawer={showSingleMeetingDrawer}
                                      name={meeting.info?.name || 'No meeting data'}
                                      meetingParticipation={meeting.participant?.member?.type || 'original'}
                                      date={monthRangeSeleced ? formatDate(meeting.originalDate) : dayjs(meeting?.meetingDate).format("YYYY-MM-DD")}
                                      time={meeting.info ? `${formatTime(meeting.info.startDate)} - ${formatTime(meeting.info.endDate)}` : 'No meeting data'}
                                      status={meeting.participant?.member?.attendance === 'mandatory' ? 'Yes' : meeting.participant?.member?.rsvp === 'Default' ? 'RSVP' : meeting.participant?.member?.rsvp || 'RSVP'}
                                      triggerMeetings={triggerMeetings}
                                      setTriggerMeetings={setTriggerMeetings}
                                      openNotificationWithIcondd={openNotificationWithIcon}
                                    />
                                  ))}
                                </div>
                              </div>
                            ))
                          }
                          <Pagination
                            align='end'
                            current={tab3Meetings.currentPage}
                            total={tab3Meetings.filteredCount}
                            pageSize={pageSize}
                            onChange={handlePageChange}
                            showSizeChanger={false}
                          />
                        </>
                      )
                    }
                  </Flex>
                ),
              },
            ],
            {
              label: (
                <span style={{ color: colorError }}>
                  <FileZipOutlined style={{ color: colorError }} /> Old Archive
                </span>
              ),
              key: '4',
              children: (
                <Flex vertical gap={16} style={{ width: '100%' }}>
                  {
                    skeletonLoading ? (
                      <CommonSkeletonLoader itemCount={2} />
                    ) : Array.isArray(tab4Meetings?.grouped) && tab4Meetings.grouped.length === 0 ? (
                      <Flex align="center" justify="center" style={{ minHeight: 200 }}>
                        <Empty
                          image={Empty.PRESENTED_IMAGE_SIMPLE}
                          description={<span>No archived meetings found.</span>}
                        />
                      </Flex>
                    ) : (
                      <>
                        <LegacyArchiveMeetingPreviewCardList
                          groupedMeetings={tab4Meetings?.grouped}
                          onViewMeeting={showArchivedDrawer}
                        />
                        <Pagination
                          align='end'
                          current={tab4Meetings.currentPage}
                          total={tab4Meetings.hasNextPage ? ((tab4Meetings.currentPage || 1) * pageSize) + 1 : (tab4Meetings.filteredCount || 0)}
                          pageSize={pageSize}
                          onChange={handlePageChange}
                          showSizeChanger={false}
                        />
                      </>
                    )
                  }
                </Flex>
              ),
            },
          ]}
        />

        <Drawer
          title="Respond to Meeting"
          open={openMeetingDrawer}
          onClose={closeSingleMeetingDrawer}
          size='large'
        >
          {
            rsvpDrawerLoading ? (<><CommonSkeletonLoader /></>) :
              selectedSingleMeeting !== null ? (
                <MyEvents
                  id={selectedSingleMeeting.meeting._id}
                  name={selectedSingleMeeting.meeting.info.name}
                  date={selectedMeetingDate}
                  time={`${formatTime(selectedSingleMeeting.meeting.info.startDate)} - ${formatTime(selectedSingleMeeting.meeting.info.endDate)}`}
                  company='default'
                  status={selectedMeetingStatus}
                  participants={selectedParticipantDetails ? selectedParticipantDetails.flatMap(day => day.meetings).find(meeting => meeting._id == selectedSingleMeeting.meeting._id) : null}
                  closeDrawer={closeSingleMeetingDrawer}
                  meetingFullData={selectedSingleMeeting}
                />
              ) : (<></>)
          }
        </Drawer>

        {/* <Drawer title='Schedule Conflict Alert'
          size='large'
          placement='left'
          footer={[
            <Flex justify='flex-end' align='center' gap='large'>
              <Button>
                Cancel
              </Button>
              <Button type="primary">
                Modify
              </Button>
              <Button type="primary">
                Accept
              </Button>
            </Flex>
          ]
          }

        >
          <Content>
            <ConflictManagement />
          </Content>
        </Drawer> */}

        <CreateNewMeetingDrawer
          openDrawer={openNewMeetingDrawer}
          closeDrawer={onCloseNewMeetingDrawer}
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
          isRecurring={isRecurring}
          setIsRecurring={setIsRecurring}
          selectedDays={selectedDays}
          setSelectedDays={setSelectedDays}
          value2={value2}
          setValue2={setValue2}
          current={current}
          setCurrent={setCurrent}
          isPrevClickedToGeneral={isPrevClickedToGeneral}
          isPrevClickedToCommittee={isPrevClickedToCommittee}
          setIsPrevClickedToGeneral={setIsPrevClickedToGeneral}
          setIsPrevClickedToCommittee={setIsPrevClickedToCommittee}
          actionState={actionState}
          setActionState={setActionState}
          finalAddedPapersList={finalAddedPapersList}
          setFinalAddedPapersList={setFinalAddedPapersList}
        />

        <ArchivedMeetingDetails
          open={openArchivedDrawer}
          onClose={onCloseArchivedDrawer}
          meetingData={selectedArchivedMeeting}
          companyId={companyId}
          token={token}
        />
      </Flex>
    </>
  )
}